// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import QuestionCircleOutlinedSvg from "@ant-design/icons-svg/lib/asn/QuestionCircleOutlined";
import AntdIcon from "../components/AntdIcon";
const QuestionCircleOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: QuestionCircleOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    QuestionCircleOutlined.displayName = "QuestionCircleOutlined";
}
export default /*#__PURE__*/ React.forwardRef(QuestionCircleOutlined);
